// client/src/lib/wire.ts — reading numbers off the generated contract · PROP-004.
//
// `openapi/v1.json` describes every numeric member — `decimal`, `int`, `short` — as
// `type: ["number", "string"]` with a numeric pattern, and the generated types follow it:
// `amount: number | string`, `totalCount: number | string`. That is System.Text.Json's
// `AllowReadingFromString` speaking through the schema exporter: the API will ACCEPT a number
// spelled as a string, so the input side is truthful; on the OUTPUT side the API never writes
// one, so the union is wider than anything that reaches the browser. See DEVIATIONS D-360.
//
// Rather than sprinkle `Number(x)` through the screens — which would also silently accept a
// non-numeric string as NaN — the coercion lives here, once, and says what it assumes.

/** A wire numeric as the contract types it. */
export type WireNumber = number | string;

/**
 * A number the contract may have typed as a string. `Number()` is the right reading of the
 * schema's own pattern (`^-?(?:0|[1-9]\d*)(?:\.\d+)?$`); anything the pattern would not admit
 * is a broken response, and NaN is the honest value for it — it renders as „NaN" rather than
 * as a plausible figure.
 */
export function wireNumber(value: WireNumber): number {
  return typeof value === 'number' ? value : Number(value);
}

/** The nullable form, for the optional columns of 03 §7.2. */
export function wireNumberOrNull(value: WireNumber | null | undefined): number | null {
  return value === null || value === undefined ? null : wireNumber(value);
}
